import LogoDark, { LogoDarkProps } from './LogoDark';

export type { LogoDarkProps };
export default LogoDark;
